import { createContext, useContext, useState } from 'react';
export const TimelineDisplay = createContext('preview');
/** Explicit choices survive item updates and changes to the default display mode. */
export function useItemDisclosure() {
    const mode = useContext(TimelineDisplay);
    const [choice, setChoice] = useState();
    return {
        expanded: choice === true,
        preview: choice === undefined && mode === 'preview',
        toggle: () => setChoice(current => current !== true),
    };
}
//# sourceMappingURL=TimelineDisplay.js.map